import { Provider } from "mobx-react";
import React from "react";
import ReactDOM from "react-dom";
import stores from "./Stores";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { RouterStore, syncHistoryWithStore } from "mobx-react-router";
import "react-toastify/dist/ReactToastify.min.css";
import App from "./App";
import "./index.scss";

const browserHistory = createBrowserHistory();
const routingStore = new RouterStore();

const appStores = {
  ...stores,
  routing: routingStore,
};

const history = syncHistoryWithStore(browserHistory, routingStore);
console.log("Build time (UTC): {build_time}");

ReactDOM.render(
  <Provider {...appStores}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
